import { 
        SET_MODAL_FILTERS, 
        TOGGLE_DEEP_DIVE_MODAL, 
        HANDLE_SENTIMENT_CHANGE,
        REMOVE_SENTIMENT_CHANGE, 
        HANDLE_THEME_CHANGE,
        REMOVE_THEME_CHANGE,
        REMOVE_SOURCES_CHANGE, 
        HANDLE_SOURCES_CHANGE } from '../actions/deepDiveAction';
// import { isFulfilled, isPending, isRejected } from "./reducerUtils";

const deepDiveReducer = (
    state = {
        deepDiveModal: false,
        appliedFilters: {},
        appliedSentiment: '',
        appliedTheme: '',
        appliedSource: '',
        originalSentiment: [],
        originalInfluencers: [],
        originalTopics: [],
        originalSubtopics: []
    },
    action 
) => {
    switch(action.type) {
        case SET_MODAL_FILTERS:
            return {
                ...state,
                appliedFilters: action.payload,
                originalSentiment: action.payload.filter_json.sentiment,
                originalInfluencers: action.payload.filter_json.influencers,
                originalTopics: action.payload.filter_json.topics,
                originalSubtopics: action.payload.filter_json.subtopics
            }
        case HANDLE_SENTIMENT_CHANGE:
            return {
                ...state,
                appliedSentiment: action.payload,
                appliedFilters: {...state.appliedFilters, filter_json: {...state.appliedFilters.filter_json, sentiment: [action.payload]}}, 
            }
        case REMOVE_SENTIMENT_CHANGE:
                return {
                    ...state,
                    appliedSentiment: '',
                    appliedFilters: {...state.appliedFilters, filter_json: {...state.appliedFilters.filter_json, sentiment: state.originalSentiment }}, 
                }
        case HANDLE_SOURCES_CHANGE:
            return {
                ...state,
                appliedSource: action.payload, 
                appliedFilters: {...state.appliedFilters, filter_json: {...state.appliedFilters.filter_json, influencers: [action.payload]}}, 
            }
        case REMOVE_SOURCES_CHANGE:
            return {
                ...state,
                appliedSource: '',
                appliedFilters: {...state.appliedFilters, filter_json: {...state.appliedFilters.filter_json, influencers: state.originalInfluencers }}, 
            }
        case HANDLE_THEME_CHANGE:
            return {
                ...state,
                appliedTheme: action.payload, 
                appliedFilters: {...state.appliedFilters, filter_json: {...state.appliedFilters.filter_json, topics: [action.payload], subtopics: []}}, 
            }
        case REMOVE_THEME_CHANGE:
            return {
                ...state,
                appliedTheme: '',
                appliedFilters: {...state.appliedFilters, filter_json: {...state.appliedFilters.filter_json, topics: state.originalTopics, subtopics: state.originalSubtopics}}, 
            }
        case TOGGLE_DEEP_DIVE_MODAL: 
            return {
                ...state,
                deepDiveModal: !state.deepDiveModal
            }
        default:
            return {
                ...state
            }
    }
}

export default deepDiveReducer;